import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getCompany } from 'lib/selectors/getCompany';

const getJobDisplayNameFormat = createSelector([getCompany], (company) => {
  return _get(company, 'jobDisplayNameFormat', '');
});

export { getJobDisplayNameFormat };
